export const PoolsAccessoriesSection = {
  title: 'Accesorios',
  description:
    'La cámara Rollo Cover de Compass Pools es parte integral de su piscina y contiene un mecanismo sumergido con ruedas guía. Cuando se abren o cierran automáticamente, las lamas se guían suavemente y se enrollan alrededor de un rodillo de acero inoxidable. Las lamas están accionadas por un sofisticado motor de rodillos instalado en la cámara de la cubierta. Al abrirse, las lamas de la cubierta quedan invisiblemente sumergidas bajo el nivel del agua detrás de un panel fijo del mismo color que la piscina.',
  compasRolloCover: 'Compass Rollo Cover',
  copingStones: 'Coping stones',
};
